import './index.css';

import * as React from 'react';
import { connect } from 'react-redux';
import Group from 'src/entities/Group';
import Member from 'src/entities/Member';

import {
  destroyMemo,
  readMemo,
  readMemosSearch,
  truncateMemos,
  updateMemo,
  updateMemos
} from '../../actions/memo';
import Memo from '../../entities/Memo';
import Cancel from '../../res/img/cancel_gray.svg';
import LoupeGreenLight from '../../res/img/loupe_green_light.svg';
import MemoItem from '../Memo/item';
import OtherActions from '../Memo/otherActions';
import Navigation from '../Navigation/global';
import MemoSort from '../Navigation/memoSort';

interface IProps {
  account: Member;
  memos: Memo[];
  groups: Group[];
  members: Member[];
  keyword: string;
  readMemo: (memo: Memo) => void;
  updateMemo: (memo: Memo) => void;
  updateMemos: (memo: Memo[]) => void;
  destroyMemo: (memo: Memo) => void;
  readMemosSearch: (keyword: string, offset: number) => void;
  truncateMemos: () => void;
}

interface IState {
  doesShowPopup: boolean;
  popupMemoId: number;
  apiSearched: boolean;
  keyword: string;
  keywordFixed: string;
  sortFunc: any;
  filterFunc: any;
  offset: number;
  isFocus: boolean;
  countMemos: number;
  isFullyLoaded: boolean;
  keyDownCode: number;
}

class SearchIndexComponent extends React.Component<IProps, IState> {
  searchInput: HTMLInputElement;

  constructor(props: any) {
    super(props);
    this.state = {
      doesShowPopup: false,
      popupMemoId: 0,
      apiSearched: false,
      keyword: this.props.keyword !== undefined ? this.props.keyword : '',
      keywordFixed: '',
      sortFunc: undefined,
      filterFunc: undefined,
      isFocus: true,
      isFullyLoaded: false,
      countMemos: 0,
      offset: 0,
      keyDownCode: 0
    };

    this.onChangeKeyword = this.onChangeKeyword.bind(this);
    this.setSortFunc = this.setSortFunc.bind(this);
    this.confirmCandidates = this.confirmCandidates.bind(this);
    this.onFocusKeyword = this.onFocusKeyword.bind(this);
    this.onBlurKeyword = this.onBlurKeyword.bind(this);
    this.searchKeywords = this.searchKeywords.bind(this);
    this.searchKeywordsMore = this.searchKeywordsMore.bind(this);
    this.monitorKeyDownCode = this.monitorKeyDownCode.bind(this);
    this.showPopup = this.showPopup.bind(this);
    this.hidePopup = this.hidePopup.bind(this);
  }

  componentWillMount() {
    this.props.truncateMemos();
  }

  componentDidMount() {
    this.searchInput.focus();
    this.setState({
      filterFunc: () => true
    });
  }

  componentDidUpdate() {
    if (this.state.countMemos !== this.props.memos.length) {
      console.log(this.props.memos.length, this.state.countMemos);
      this.setState({
        countMemos: this.props.memos.length,
        isFullyLoaded: this.props.memos.length - this.state.countMemos !== 30
      });
    }
  }

  render() {
    const keywordList = this.state.keyword
      .split(/\s+/)
      .filter(keyword => keyword.length > 0);

    let memos: Memo[] = [];

    if (this.state.apiSearched && this.state.keyword !== '') {
      memos = this.props.memos.filter(memo =>
        keywordList
          .filter(
            keyword =>
              keyword.slice(0, 1) !== '@' && keyword.slice(0, 1) !== '＠'
          )
          .map(keyword => {
            const memberCandidate = this.props.members.find(
              member => member.nameLast === keyword
            );
            let memberId = 0;
            if (memberCandidate !== undefined) {
              memberId = memberCandidate.id;
            }

            return (
              memo.id === Number(keyword) ||
              memo.memo.includes(keyword) ||
              memo.comments.filter(comment => comment.text.includes(keyword))
                .length > 0 ||
              memo.tags.filter(
                tag => '#' + tag === keyword || '＃' + tag === keyword
              ).length > 0 ||
              memo.reporters.includes(memberId) ||
              memo.performers.includes(memberId)
            );
          })
          .every(bool => bool === true)
      );

      const groupKeywordList = keywordList.filter(
        keyword => keyword.slice(0, 1) === '@' || keyword.slice(0, 1) === '＠'
      );
      if (groupKeywordList.length > 0) {
        const groupFilters: number[] = [];
        groupKeywordList.map(keyword => {
          const groupPossible = this.props.groups.find(
            group =>
              '@' + group.title === keyword || '＠' + group.title === keyword
          );
          if (groupPossible !== undefined) {
            groupFilters.push(groupPossible.id);
          }
        });

        memos = memos.filter(memo => groupFilters.includes(memo.groupId));
      }

      if (this.state.filterFunc !== undefined) {
        memos = memos.filter(this.state.filterFunc);
      }

      if (this.state.sortFunc !== undefined) {
        memos = memos.sort(this.state.sortFunc);
      }
    }

    const keywordReadyNext =
      this.state.keyword.length > 0 &&
      this.state.keyword.split(/\s+/).slice(-1)[0].length === 0;

    const popupMemo = this.props.memos.find(
      memo => memo.id === this.state.popupMemoId
    );

    return (
      <div id="SearchIndex">
        <Navigation group="メモの検索" />

        <div id="NavigationFunction">
          <div id="NavigationFunctionLeft">
            <img src={LoupeGreenLight} />
            <input
              ref={searchInput => {
                this.searchInput = searchInput as HTMLInputElement;
              }}
              className="InputText"
              value={this.state.keyword}
              onChange={this.onChangeKeyword}
              onKeyDown={this.monitorKeyDownCode}
              onKeyUp={this.confirmCandidates}
              onFocus={this.onFocusKeyword}
              onBlur={this.onBlurKeyword}
              placeholder="キーワードを入力"
            />
            <div id="Keywords">
              {keywordList.map((keyword, index) => {
                const isLastKeyword = index + 1 === keywordList.length;
                if (
                  // tags
                  ['#', '＃'].includes(keyword.slice(0, 1))
                ) {
                  return (
                    <div
                      className={
                        !keywordReadyNext && isLastKeyword
                          ? 'KeywordTag KeywordCandidate'
                          : 'KeywordTag'
                      }
                    >
                      {keyword}
                    </div>
                  );
                } else if (
                  // member
                  this.props.members.find(
                    member => member.nameLast === keyword
                  ) !== undefined
                ) {
                  return (
                    <div
                      className={
                        !keywordReadyNext && isLastKeyword
                          ? 'KeywordMember KeywordCandidate'
                          : 'KeywordMember'
                      }
                    >
                      {
                        (this.props.members.find(
                          member => member.nameLast === keyword
                        ) as Member).nameLast
                      }
                    </div>
                  );
                } else {
                  // other
                  return (
                    <div
                      className={
                        !keywordReadyNext && isLastKeyword
                          ? 'KeywordOther KeywordCandidate'
                          : 'KeywordOther'
                      }
                    >
                      {keyword}
                    </div>
                  );
                }
              })}
              {this.state.isFocus ? (
                <div
                  className={
                    keywordReadyNext
                      ? 'DummyFocus DummyFocusNext'
                      : 'DummyFocus'
                  }
                />
              ) : null}
            </div>

            {this.state.keyword.length > 0 && !this.state.apiSearched ? (
              <button
                id="GoSearch"
                onMouseUp={this.searchKeywords}
                onTouchEnd={this.searchKeywords}
              >
                すべてを検索
              </button>
            ) : null}
          </div>
          <div id="NavigationFunctionRight">
            <MemoSort
              setSortFunc={this.setSortFunc}
              account={this.props.account}
            />
            <OtherActions
              account={this.props.account}
              memos={memos}
              members={this.props.members}
              updateMemos={this.props.updateMemos}
            />
          </div>
        </div>

        <div id="Memos">
          {memos.map(memo => (
            <MemoItem
              key={memo.id}
              memo={memo}
              group={
                this.props.groups.find(
                  group => group.id === memo.groupId
                ) as Group
              }
              groups={this.props.groups}
              members={this.props.members}
              account={this.props.account}
              updateMemo={this.props.updateMemo}
              destroyMemo={this.props.destroyMemo}
              togglePopup={this.showPopup}
              keywordList={keywordList}
            />
          ))}

          {this.props.memos.length > 0 && !this.state.isFullyLoaded ? (
            <div id="LoadContainer">
              <button id="LoadMore" onClick={this.searchKeywordsMore}>
                さらに読み込む
              </button>
              {/* <button id="LoadAll" onClick={this.searchKeywordsMore}>
                すべて読み込む
              </button> */}
            </div>
          ) : null}
        </div>

        {this.state.doesShowPopup && popupMemo !== undefined ? (
          <div id="PopupMemo">
            <div className="Delete" onClick={this.hidePopup}>
              <img src={Cancel} />
            </div>
            <div id="PopupMemoItem">
              <MemoItem
                memo={popupMemo}
                group={
                  this.props.groups.find(
                    group => group.id === popupMemo.groupId
                  ) as Group
                }
                groups={this.props.groups}
                members={this.props.members}
                account={this.props.account}
                updateMemo={this.props.updateMemo}
                destroyMemo={this.props.destroyMemo}
                togglePopup={this.showPopup}
              />
            </div>
          </div>
        ) : null}
      </div>
    );
  }

  onFocusKeyword(e: any) {
    this.setState({
      isFocus: true
    });
  }

  onBlurKeyword(e: any) {
    this.setState({
      isFocus: false
    });
  }

  onChangeKeyword(e: any) {
    this.setState({
      keyword: e.target.value
    });
    this.setState({
      apiSearched: false
    });
  }

  setSortFunc(sortFunc: any, filterFunc: any) {
    this.setState({
      sortFunc,
      filterFunc
    });
  }

  monitorKeyDownCode(e: any) {
    this.setState({
      keyDownCode: e.which
    });
  }

  confirmCandidates(e: any) {
    if (e.keyCode === 13) {
      if (this.state.keyword.slice(-1) !== ' ') {
        this.setState({
          keyword: this.state.keyword + ' '
        });
      }

      if (e.which === this.state.keyDownCode) {
        this.props.readMemosSearch(this.state.keyword, 0);
        this.setState({
          apiSearched: true,
          offset: 1
        });
      }
    }
  }

  searchKeywords(e: any) {
    this.props.readMemosSearch(this.state.keyword, 0);
    this.setState({
      apiSearched: true,
      offset: 1
    });
  }

  searchKeywordsMore(e: any) {
    this.props.readMemosSearch(this.state.keyword, this.state.offset);
    this.setState({
      apiSearched: true,
      offset: this.state.offset + 1
    });
  }

  showPopup(memoId: number) {
    const memo = new Memo();
    memo.id = memoId;
    this.props.readMemo(memo);
    this.setState({
      doesShowPopup: true,
      popupMemoId: memoId
    });
  }

  hidePopup(e: any) {
    this.setState({
      doesShowPopup: false,
      popupMemoId: 0
    });
  }
}

const mapStateToProps = (state: any, ownProps: any) => ({
  account: state.Account,
  members: state.Member,
  groups: state.Group,
  memos: state.Memo,
  keyword: ownProps.match.params.keyword
});

const mapDispatchToProps = (dispatch: any) => {
  return {
    readMemo(memo: Memo) {
      dispatch(readMemo(memo));
    },
    updateMemo(memo: Memo) {
      dispatch(updateMemo(memo));
    },
    updateMemos(memos: Memo[]) {
      dispatch(updateMemos(memos));
    },

    readMemosSearch(keyword: string, offset: number) {
      dispatch(readMemosSearch(keyword, offset));
    },
    destroyMemo(memo: Memo) {
      dispatch(destroyMemo(memo));
    },
    truncateMemos() {
      dispatch(truncateMemos());
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchIndexComponent);



// WEBPACK FOOTER //
// ./src/components/Search/index.tsx